import React from "react";
import Grid from "@mui/material/Grid";
import { colors, statusColor } from "../Styles";

export const ColoredGrid = ({ status, sx, children, ...rest }) => {
  const color = statusColor[status] || "grey";
  const bgcolor = colors[color].light;

  return (
    <Grid
      sx={{
        bgcolor,
        "& > div:first-of-type": {
          borderLeft: "1px solid #ccc",
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Grid>
  );
}
